/**
 * Created by kim on 23.11.16.
 */
export const SHIPMENT_CRON_READ_REQUEST = "SHIPMENT_CRON_READ_REQUEST";
export const SHIPMENT_CRON_READ = "SHIPMENT_CRON_READ";
export const SHIPMENT_CRON_CREATE = "SHIPMENT_CRON_CREATE";
export const SHIPMENT_CRON_CREATE_REQUEST = "SHIPMENT_CRON_CREATE_REQUEST";
// export const MESSAGE_UPDATE = "MESSAGE_UPDATE";
